import React from "react";
import { useLang } from "@/context/LanguageContext";
import { useAuth } from "@/context/AuthContext";
import Seo from "@/components/Seo";
import CommunityManager from "@/components/CommunityManager";
import { Shield } from "lucide-react";

export default function AdminCommunity() {
  const { t } = useLang();
  const { user, loading } = useAuth();
  if (loading) return <div className="py-24 text-center text-stone-400">{t("loading")}</div>;
  if (!user || user.role !== "admin") return <div className="py-24 text-center text-stone-400">403</div>;
  return (
    <>
      <Seo title={t("com_admin_title")} canonicalPath="/admin/community" noindex />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12 py-12">
        <div className="flex items-center gap-3 mb-4 border-b border-amber-900/30 pb-5">
          <Shield className="w-7 h-7 text-amber-500" />
          <h1 className="font-serif text-3xl sm:text-4xl uppercase tracking-tight text-amber-100">{t("com_admin_title")}</h1>
        </div>
        <CommunityManager />
      </div>
    </>
  );
}
